<app-dialog
  [title]="'marketScanId.title' | translate"
  [confirmation]="'marketScanId.button' | translate"
  (save)="onSubmit()"
>
  <div id="market-scan-id-dialog">
    <div mat-dialog-content>
      <p>{{ 'marketScanId.description' | translate }}</p>
    </div>
    <ng-container *ngIf="!isLoadingData; else loader">
      <form [formGroup]="formGroup" class="d-flex">
        <div class="container-fluid">
          <div class="row">
            <div class="col-8">
              <mat-label class="d-flex">{{ 'marketScanId.marketScanId' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="market_scan_id"
                       [placeholder]="'marketScanId.marketScanId' | translate">
              </mat-form-field>
            </div>
            <div class="col">
              <button mat-raised-button color="primary" class="w-100 text-center" (click)="idSearch()">
                {{ 'marketScanId.search' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-template #loader>
      <ngx-skeleton-loader [theme]="{ width: '100%', height: '50px' }"></ngx-skeleton-loader>
    </ng-template>
  </div>
</app-dialog>

